/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharedplan_SupersetInputs */

const en_us2_sharedplan_superset = /** @type {(inputs: Sharedplan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`in a superset`)
};

const pt_br2_sharedplan_superset = /** @type {(inputs: Sharedplan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`em superset`)
};

const pt_pt2_sharedplan_superset = /** @type {(inputs: Sharedplan_SupersetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`em superset`)
};

/** @type {(inputs: Sharedplan_SupersetInputs) => LocalizedString} */
const es_419_sharedplan_superset = en_us2_sharedplan_superset;

/** @type {(inputs: Sharedplan_SupersetInputs) => LocalizedString} */
const fr_fr2_sharedplan_superset = en_us2_sharedplan_superset;

/** @type {(inputs: Sharedplan_SupersetInputs) => LocalizedString} */
const de_de2_sharedplan_superset = en_us2_sharedplan_superset;

/** @type {(inputs: Sharedplan_SupersetInputs) => LocalizedString} */
const it_it2_sharedplan_superset = en_us2_sharedplan_superset;

/**
* | output |
* | --- |
* | "in a superset" |
*
* @param {Sharedplan_SupersetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const sharedplan_superset = /** @type {((inputs?: Sharedplan_SupersetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharedplan_SupersetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_sharedplan_superset(inputs)
	if (locale === "es-419") return es_419_sharedplan_superset(inputs)
	if (locale === "pt-PT") return pt_pt2_sharedplan_superset(inputs)
	if (locale === "fr-FR") return fr_fr2_sharedplan_superset(inputs)
	if (locale === "de-DE") return de_de2_sharedplan_superset(inputs)
	if (locale === "it-IT") return it_it2_sharedplan_superset(inputs)
	return en_us2_sharedplan_superset(inputs)
});
export { sharedplan_superset as "sharedplan.superset" }